var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutPattern2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6784 42.5511C8.30506 39.0394 -2.54119 30.8745 1.67562 25.58C5.89245 20.2855 18.3683 28.6578 24.0791 33.5057C18.8259 28.584 9.60785 17.1229 14.7618 10.6519C18.2752 6.24058 23.2985 9.70752 27.2673 14.278C24.707 9.9011 22.9487 4.87957 25.3223 1.89934C29.0706 -2.80685 37.5673 5.05308 41.3472 9.57133C43.2597 5.41742 48.7192 -1.48741 55.2574 4.12446C61.7956 9.73635 52.2592 14.6491 46.6737 16.404C50.5755 18.7661 57.3449 24.9389 53.2086 30.7332C49.4316 36.0242 42.0496 30.851 37.969 26.7894C41.9094 31.062 48.2662 39.6764 41.4952 45.44C35.0086 50.9616 29.2443 44.3193 27.326 39.0792C28.8144 45.5601 29.2388 56.2049 24.2724 56.5483C18.7009 56.9337 15.6633 46.8264 15.6784 42.5511Z",
    fill: "#86E0C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPattern2);
export default __webpack_public_path__ + "static/media/about-pattern2.4057183b0876d42f428e31a3b0582e50.svg";
export { ForwardRef as ReactComponent };